import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store/rootReducers';
import { setDashboard } from '../../store/slices/DashboardSlice';
import { request } from '../../Utils/request';
import IntroSlider from '../../Components/IntroSlider';

const IntroSliderPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const banners = useSelector((state: RootState) => state.dashboard.introSliders);
  const location = useSelector((state: RootState) => state.location.location);

  useEffect(() => {
    const fetchLanding = async () => {
      let endpoint = '/landing';
      
      // Add location parameters if available
      if (location?.lat && location?.lng) {
        const queryParams = new URLSearchParams({
          latitude: location.lat.toString(),
          longitude: location.lng.toString(),
        });
        endpoint = `${endpoint}?${queryParams.toString()}`;
      }
      
      const res = await request(endpoint, {
        method: 'GET',
      }) as any;
      console.log("landing", res.data);
      dispatch(setDashboard({
        banners: res.data.banners,
        introSliders: res.data.introSliders,
        categories: res.data.postCategories,
        newPlaces: res.data.newPlaces,
        curatedPlaces: res.data.curatedPlaces,
        tripsItinerary: res.data.tripsItinerary,
      }));
    }
    fetchLanding();
  }, [dispatch, location]);

  const handleIntroComplete = () => {
    localStorage.setItem('hasSeenIntroSlider', 'true');
    navigate('/');
  };

  const handleIntroSkip = () => {
    localStorage.setItem('hasSeenIntroSlider', 'true');
    navigate('/');
  };

  // Show loading or redirect if no banners
  if (!banners || banners.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <IntroSlider
      slides={banners}
      onComplete={handleIntroComplete}
      onSkip={handleIntroSkip}
    />
  );
};

export default IntroSliderPage;
